export function animatedWords() {
  $('.animated-words').each(function(){
    let $headline = $(this);
    let $words = $headline.find('b');
    let $first = $words.eq(0)
    $first.addClass('is-visible');
    $words.each(function(){
      singleLetter($(this))
    });
    $headline.css('width', $first.width());
    setTimeout(function(){ hideWord($first) }, 2500);
  });
}

function singleLetter(word) {
  let letters = word.text().split(''),
  selected = word.hasClass('is-visible');
  for(let i in letters) {
    letters[i] = '<em>' + letters[i] + '</em>';
    letters[i] = (selected) ? '<i class="in">' + letters[i] + '</i>': '<i>' + letters[i] + '</i>';
  }
  let newLetters = letters.join('');
  word.html(newLetters).css('opacity', 1);
}

function hideWord($word) {
  let $nextWord = takeNext($word);
  let bool = ($word.children('i').length >= $nextWord.children('i').length) ? true : false;
  let $headline = $word.closest('.animated-words')
  $headline.css('width', $nextWord.width());
  toggleLetter($word.find('i').eq(0), $word, bool, 25, false);
  toggleLetter($nextWord.find('i').eq(0), $nextWord, bool, 25, true);
}

function toggleLetter($letter, $word, bool, duration, show) {
  $letter.toggleClass('in', show).toggleClass('out', !show)
  if(!$letter.is(':last-child')) {
    setTimeout(function(){ toggleLetter($letter.next(), $word, bool, duration, show); }, duration);
  } else if(bool && !show) {
    setTimeout(function(){ hideWord(takeNext($word)) }, 2500);
  } else if(!bool && show) {
    setTimeout(function(){ hideWord($word) }, 2500)
  }
}

function takeNext($word) {
  return (!$word.is(':last-child')) ? $word.next() : $word.parent().children().eq(0);
}
